import get from 'lodash/get';

import { createReducer } from '../../utils';
import types from './types';

// TODO Make id null by default, don't use undefined
export const initialState = {
    id: undefined,
};

const SYNC_ACTION_HANDLERS = {
    [types.SET_PRELIMINARY_SESSION]: (state, action) => ({
        ...state,
        id: get(action, 'payload.id'),
        paymentMethod: get(action, 'payload.paymentMethod')
    })
};

const ASYNC_ACTION_HANDLERS = {
    // TODO Rewrite as it makes no sense at all
    [types.CANCEL_PRELIMINARY_SESSION.REQUEST]: state => ({
        ...state,
        ...initialState
    }),
    // TODO Where are SUCCESS, ERROR handlers, loading flag at least ?:)
};

const ACTION_HANDLERS = {
    ...SYNC_ACTION_HANDLERS,
    ...ASYNC_ACTION_HANDLERS
};

export default createReducer(ACTION_HANDLERS, initialState);
